export const CUSTOM_LINE_ITEM_MIDDLE_LEFT_CONTROL = 'custom-line-item-control-ml';
export const MAX_SNAPPING_THRESHOLD = 2;
export const TUNABLE_THRESHOLD_CONSTANT = 200;